// Public venue config fetch for the contact form. Reads the same widget config
// endpoint the booking loader uses, but only needs the brand colour. Best-effort:
// any failure resolves to null so the form falls back to its default colour.
export const CONFIG_API_BASE = 'https://vc9kugsjnd.execute-api.eu-north-1.amazonaws.com/dev';

export async function fetchContactConfig(slug) {
  try {
    const res = await fetch(`${CONFIG_API_BASE}/widget/config?venue=${encodeURIComponent(slug)}`, {
      method: 'GET',
      credentials: 'omit',
    });
    if (!res.ok) return null;
    const data = await res.json();
    const color = data && data.theme && data.theme.color;
    return color ? { color } : null;
  } catch {
    return null;
  }
}
